import { UserDto } from "../../types/dto";
import { isMockMode, post, simulateDelay } from "../api";

export const mapUserEmails = (data: any) => {
	data.results.map((user: any) => (user.email = user.user.email));
	return data;
};
interface UserAndRoleDto {
	user: UserDto;
	role: string;
}

interface GetUsersReturnType {
	fetched: Number;
	skipped: Number;
	totalAvailable: Number;
	orgId: string;
	results: Array<UserAndRoleDto>;
}

export const getUsers = ({
	orgId,
	skip = 0,
	take = 1000,
	search = "",
}: {
	orgId: string;
	skip?: number;
	take?: number;
	search?: string;
}) => {
	if (isMockMode()) {
		const testData = {
			fetched: 17,
			skipped: 0,
			totalAvailable: 17,
			results: [
				{
					user: {
						email: "test.mctestie@mgaol.abc",
						firstName: null,
						lastName: null,
					},
					role: "Admin",
				},
				{
					user: {
						email: "test.mctestie@mgaol.abc",
						firstName: null,
						lastName: null,
					},
					role: "Owner",
				},
				{
					user: {
						email: "test.mctestie@mgaol.abc",
						firstName: null,
						lastName: null,
					},
					role: "Guest",
				},
				{
					user: {
						email: "test.mctestie@mgaol.abc",
						firstName: null,
						lastName: null,
					},
					role: "Admin",
				},
				{
					user: {
						email: "test.mctestie@mgaol.abc",
						firstName: "Test",
						lastName: "McTestie",
					},
					role: "Admin",
				},
				{
					user: {
						email: "test.mctestie@mgaol.abc",
						firstName: null,
						lastName: null,
					},
					role: "Owner",
				},
				{
					user: {
						email: "test.mctestie@mgaol.abc",
						firstName: "Test",
						lastName: "McTestie",
					},
					role: "Admin",
				},
				{
					user: {
						email: "test.mctestie@mgaol.abc",
						firstName: null,
						lastName: null,
					},
					role: "User",
				},
				{
					user: {
						email: "test.mctestie@mgaol.abc",
						firstName: null,
						lastName: null,
					},
					role: "Owner",
				},
				{
					user: {
						email: "test.mctestie@mgaol.abc",
						firstName: null,
						lastName: null,
					},
					role: "Guest",
				},
				{
					user: {
						email: "test.mctestie@mgaol.abc",
						firstName: null,
						lastName: null,
					},
					role: "Owner",
				},
				{
					user: {
						email: "test.mctestie@mgaol.abc",
						firstName: null,
						lastName: null,
					},
					role: "Admin",
				},
				{
					user: {
						email: "test.mctestie@mgaol.abc",
						firstName: null,
						lastName: null,
					},
					role: "Owner",
				},
				{
					user: {
						email: "test.mctestie@mgaol.abc",
						firstName: "Test",
						lastName: "McTestie",
					},
					role: "User",
				},
				{
					user: {
						email: "test.mctestie@mgaol.abc",
						firstName: "Test",
						lastName: "McTestie",
					},
					role: "User",
				},
				{
					user: {
						email: "test.mctestie@mgaol.abc",
						firstName: null,
						lastName: null,
					},
					role: "Admin",
				},
				{
					user: {
						email: "test.mctestie@mgaol.abc",
						firstName: null,
						lastName: null,
					},
					role: "Owner",
				},
			],
		};

		return simulateDelay(50, () =>
			mapUserEmails(testData)
		) as Promise<GetUsersReturnType>;
	}

	return post(`orgUsers/GetUsersForOrg`, {
		orgId,
		skip,
		take,
		search,
	}).then(mapUserEmails) as Promise<GetUsersReturnType>;
};
